import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" /><path fill="none" d="M0 0h24v24H0z" /></React.Fragment>
, 'Home');
